import React, { useEffect, useState } from "react";
import CurrencyModalComponent from "./CurrencyModalComponent";
import { useSelector } from "react-redux";
import countryToCurrency from "country-to-currency";
import getSymbolFromCurrency from "currency-symbol-map";
import { toast } from "react-toastify";

import protectedAxios from "../common/axios";
import { API_URL } from "../common/constants";

export function CurrencyModalContainer({ className = "" }) {
  const currentCountry = useSelector(
    (state) => state.payments.location.country
  );
  const currentCountryCode = useSelector(
    (state) => state.payments.location.countryCode
  );
  const currencyCode = countryToCurrency[currentCountryCode];
  let currencySymbol = getSymbolFromCurrency(currencyCode);

  const [isModalActive, setIsModalActive] = useState(false);
  const [allCountries, setAllCountries] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const [selectedBillingCountry, setSelectedBillingCountry] = useState(() => {
    if (currentCountry) {
      return {
        name: currentCountry,
        code: currentCountryCode,
      };
    }

    return {
      name: "",
      code: "",
    };
  });

  function fetchAllBillingCountries() {
    setIsLoading(true);
    protectedAxios
      .get(`${API_URL}/v1/payment/collection/billing-country`)
      .then((res) => {
        if (res?.data?.Countries) {
          setAllCountries(res.data.Countries);
        } else {
          console.error(`Something went wrong!\nPlease try after sometime`);
        }
      })
      .catch((error) => {
        toast.error(
          <p>
            Unable to fetch countries!
            <br />
            Please try after sometime
          </p>
        );
        console.error(error);
      })
      .finally(() => setIsLoading(false));
  }

  useEffect(() => {
    if (isModalActive) {
      fetchAllBillingCountries();
    }
  }, [isModalActive]);

  return (
    <CurrencyModalComponent
      {...{
        isModalActive,
        setIsModalActive,
        className,
        currencyCode,
        currencySymbol,
        allCountries,
        selectedBillingCountry,
        setSelectedBillingCountry,
        isLoading,
      }}
    />
  );
}
